import { FinancialSituationCash } from '../../../../types';
export var list = [
    FinancialSituationCash.LESS_THAN_15K,
    FinancialSituationCash.BETWEEN_15K_AND_40K,
    FinancialSituationCash.BETWEEN_40K_AND_60K,
    FinancialSituationCash.ABOVE_60K,
];
